<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-项目投资-修改
    -->
    <el-dialog
    title="修改项目投资"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="60%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="120px">

      <!-- 基本信息区域 -->
      <div class="form-section">
        <h3 class="section-title">基本信息</h3>
        
        <el-form-item label="项目投资名称" prop="name" class="required-label">
          <el-input v-model="form.name" placeholder="请输入项目投资名称" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="项目分类" prop="category_id" class="required-label">
          <el-cascader
            v-model="form.category_id"
            :options="categoryOptions"
            :props="categoryProps"
            placeholder="请选择项目分类"
            clearable
            class="max-w460"
          ></el-cascader>
        </el-form-item>

        <el-form-item label="项目类目" prop="poject_menu_id" class="required-label">
          <el-select
            v-model="form.poject_menu_id"
            placeholder="请选择项目类目"
            clearable
            class="max-w460"
          >
            <el-option
              v-for="item in menuOptions"
              :key="item.poject_menu_id"
              :label="item.name"
              :value="item.poject_menu_id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="投资金额" prop="price" class="required-label">
          <el-input-number 
            v-model="form.price" 
            :min="0" 
            :precision="2" 
            :step="1000" 
            placeholder="请输入投资金额" 
            class="max-w460"
          >
            <template slot="append">元</template>
          </el-input-number>
        </el-form-item>

        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" :max="999" controls-position="right" class="max-w460"></el-input-number>
        </el-form-item>
      </div>

      <!-- 联系人信息区域 -->
      <div class="form-section">
        <h3 class="section-title">联系人信息</h3>
        
        <el-form-item label="联系人姓名" prop="contact_name" class="required-label">
          <el-input v-model="form.contact_name" placeholder="请输入联系人姓名" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="联系人电话" prop="contact_phone" class="required-label">
          <el-input v-model="form.phone" placeholder="请输入联系人电话" class="max-w460"></el-input>
        </el-form-item>

        <el-form-item label="联系人邮箱" prop="contact_email">
          <el-input v-model="form.email" placeholder="请输入联系人邮箱" class="max-w460"></el-input>
        </el-form-item>
      </div>

      <!-- 地址信息区域 -->
      <div class="form-section">
        <h3 class="section-title">地址信息</h3>
        
        <!-- <el-form-item label="所在地区" prop="region">
          <el-cascader
            v-model="form.region"
            :options="regionOptions"
            placeholder="请选择所在地区"
            class="max-w460"
          ></el-cascader>
        </el-form-item> -->

        <el-form-item label="地址" prop="address">
          <el-input 
            v-model="form.address" 
            placeholder="请输入详细地址" 
            class="max-w460"
            type="textarea"
            :rows="2"
          ></el-input>
        </el-form-item>
      </div>

      <!-- 图片信息区域 -->
      <div class="form-section">
        <h3 class="section-title">图片信息</h3>
        
        <el-form-item label="项目投资bannar：" prop="bannar" class="required-label">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.bannar">
              <transition-group>
                <div v-for="(item, index) in form.bannar" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bannar')"><i class="el-icon-close"></i></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('bannar')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
          <div class="el-form-item__tip">建议尺寸：1200×400像素，最多上传5张</div>
        </el-form-item>

        <el-form-item label="项目投资图片：" prop="image" class="required-label">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.image">
              <transition-group>
                <div v-for="(item, index) in form.image" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'album')"><i class="el-icon-close"></i></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('album')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
          <div class="el-form-item__tip">建议尺寸：800×600像素，最多上传9张</div>
        </el-form-item>
      </div>

      <!-- 详细介绍区域 -->
      <div class="form-section">
        <h3 class="section-title">详细介绍</h3>
        
        <el-form-item label="项目投资介绍" prop="intro" class="required-label">
          <div class="edit_container">
            <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
          </div>
        </el-form-item>
      </div>

      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    
    <!--商品图片组件-->
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</el-dialog>
</template>

<script>
import Project_categoryApi from '@/api/project_category.js';
import Poject_menuApi from '@/api/poject_menu.js';
import Project_investmentApi from '@/api/project_investment.js';
import Upload from '@/components/file/Upload';
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import { emit } from 'node-notifier';

export default {
  components: {
    Upload,
    Categoryas,
    draggable,
    Uediter
  },
  data() {
    // 自定义验证规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入联系人电话'));
      }
      // 手机号正则验证
      const phoneReg = /^1[3-9]\d{9}$/;
      if (!phoneReg.test(value)) {
        return callback(new Error('请输入正确的手机号码'));
      }
      callback();
    };

    const validateEmail = (rule, value, callback) => {
      if (value && value !== '') {
        // 邮箱正则验证
        const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailReg.test(value)) {
          return callback(new Error('请输入正确的邮箱格式'));
        }
      }
      callback();
    };

    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,  
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: '100%',
          initialFrameHeight: 400
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        image: [],
        category_id: [], // 用于级联选择器的数组格式
        category_id_final: null, // 最终提交的分类ID
        poject_menu_id: null, // 类目ID
        price: 0,
        sort: 50,
        intro: "",
        bannar: [],
        region: [],
        address: '',
        province: '',
        city: '',
        district: '',
        // 新增联系人字段
        contact_name: '',
        phone: '',
        email: ''
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入项目投资名称', trigger: 'blur' }],
        category_id: [{ required: true, message: '请选择项目分类', trigger: 'change' }],
        poject_menu_id: [{ required: true, message: '请选择项目类目', trigger: 'change' }],
        price: [{ required: true, message: '请输入投资金额', trigger: 'blur' }],
        address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        // 新增联系人验证规则
        contact_name: [{ required: true, message: '请输入联系人姓名', trigger: 'blur' }],
        contact_phone: [
          { required: true, message: '请输入联系人电话', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        contact_email: [
          { validator: validateEmail, trigger: 'blur' }
        ]
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      categorys: [],
      menu: [],
      code: "album",
      
      // 分类选项
      categoryOptions: [],
      categoryProps: {
        value: 'category_id',
        label: 'name',
        children: 'child',
        checkStrictly: true
      },
      
      // 类目选项
      menuOptions: [],
      
      // 地区选项
      regionOptions: [
        {
          value: 'beijing',
          label: '北京市',
          children: [
            { value: 'dongcheng', label: '东城区' },
            { value: 'xicheng', label: '西城区' },
            { value: 'chaoyang', label: '朝阳区' }
          ]
        },
        {
          value: 'shanghai',
          label: '上海市',
          children: [
            { value: 'huangpu', label: '黄浦区' },
            { value: 'xuhui', label: '徐汇区' },
            { value: 'pudong', label: '浦东新区' }
          ]
        }
      ]
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getCategoryList();
    this.getMenuList();
    this.getDetail();
  },
  props: ["open_add","project_investment_id"],
  methods: {
    // 获取分类列表
    getCategoryList() {
      let self = this;
      self.loading = true;
      Project_categoryApi.catList({}, true)
        .then(data => {
          self.loading = false;
          if (data.code === 1) {
            // 处理分类数据，转换为级联选择器需要的格式
            self.categoryOptions = self.processCategoryData(data.data.list);
          } else {
            self.$message.error('获取分类列表失败');
          }
        })
        .catch(error => {
          self.loading = false;
          self.$message.error('获取分类列表失败');
        });
    },
    
    // 处理分类数据
    processCategoryData(categories) {
      return categories.map(category => {
        const item = {
          category_id: category.category_id,
          name: category.name
        };
        
        // 如果有子分类，递归处理
        if (category.child && category.child.length > 0) {
          item.child = this.processCategoryData(category.child);
        }
        
        return item;
      });
    },
    
    // 获取类目列表
    getMenuList() {
      let self = this;
      Poject_menuApi.list()
        .then(data => {
          if (data.code === 1) {
            self.menuOptions = data.data.list.data;
          } else {
            self.$message.error('获取类目列表失败');
          }
        })
        .catch(error => {
          self.$message.error('获取类目列表失败');
        });
    },

    // 获取详情
    getDetail() {
      let self = this;
      Project_investmentApi.detail({project_investment_id: self.project_investment_id}, true)
        .then(res => {
          if (res.code === 1) {
            const data = res.data;
            
            // 填充表单数据
            self.form = {
              ...self.form,
              ...data,
              // 处理分类ID为级联选择器需要的数组格式
              category_id: data.category_id,
              category_id_final: data.category_id,
              // 处理地区数据
              region: data.province && data.city ? 
                [data.province, data.city, data.district || ''] : [],
              // 确保联系人字段存在
              contact_name: data.contact_name || '',
              phone: data.phone || '',
              email: data.email || ''
            };
            
            self.ueditor.text = self.form.intro;
            
            // 确保图片数组存在
            if (!self.form.bannar) {
              self.form.bannar = [];
            }
            if (!self.form.image) {
              self.form.image = [];
            }
          }
        })
        .catch(error => {
          self.$message.error('获取详情失败');
        });
    },

    chooseCategory() {
      this.iscategorya = true;
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    
    cancelFunc() {
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      
      // 处理地区数据
      if (form.region && form.region.length > 0) {
        form.province = form.region[0];
        form.city = form.region[1];
        form.district = form.region[2] || '';
      }
      
      form.intro = this.$refs.ue.getUEContent();
      
      // 准备提交的数据
      const submitData = {
        project_investment_id: self.project_investment_id,
        name: form.name,
        category_id: form.category_id,
        poject_menu_id: form.poject_menu_id,
        price: form.price,
        sort: form.sort,
        intro: form.intro,
        image: form.image,
        bannar: form.bannar,
        province: form.province,
        city: form.city,
        district: form.district,
        address: form.address,
        // 新增联系人数据
        contact_name: form.contact_name,
        phone: form.phone,
        email: form.email
      };
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Project_investmentApi.edit(submitData, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
              self.$message.error('提交失败');
            });
        }
      });
    },

    /*打开上传图片*/
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (e != null) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1];
          imgExpt.forEach((e) => {
            if (e === ext) {
              prevent = true
              return false
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        if (this.code == 'album') {
          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        } else {
          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index, code) {
      if (code == 'album') {
        this.form.image.splice(index, 1);
      } else if (code == 'bannar') {
        this.form.bannar.splice(index, 1);
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
          margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

/* 新增样式 */
.form-section {
  margin-bottom: 24px;
  padding: 16px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
}

.section-title {
  margin: 0 0 16px 0;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
  color: #303133;
  font-size: 16px;
  font-weight: 600;
}

.required-label .el-form-item__label::before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}

.el-form-item__tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.max-w460 {
  width: 100%;
  max-width: 460px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/project_investment/index/part/edit.vue